
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.RuleManager = (function () {

    function RuleManager (form) {

        this.rules = {};
        this.values = null;
        this.entityToAction = form.entityToAction;
        this.nextRule = 0;

        var clearRules = function () {
            this.rules = {};
            this.fieldsContainer.innerHTML = '';
        }.bind(this);

        this.validate = function (controller) {
            this.rootEl.className = 'rulesSection';
            if (!Object.keys(this.rules).length) {
                controller.allow_submit.status = false;
                controller.allow_submit.errorMessages.push(
                    Monet.Form.Messages.mountErrorMessageObject("panelbuilder.mandatory.rule"));
                this.rootEl.className += ' control-group error';
            }
        };

        this.setValues = function (values) {
            if (values) {
                clearRules();
                this.values = values;
                for (var i = 0, length = values.length; i < length; i++) {
                    var rule = this.generateRuleCondition();
                    rule.setValue(values[i]);
                    rule.setPriority(i);
                }
            }
        };

        this.getRulesValue = function () {
            var rules       = [],
                rulesNode = document.querySelectorAll('.fieldsContainer .rule');

            Object.keys(rulesNode).forEach(function (i) {
                i = parseInt(i);

                if(rulesNode[i]) {
                    var rule = this.rules[rulesNode[i].getAttribute('data-id')];
                    rule.setPriority(i + 1);
                    rules.push(rule.getValue());
                }
            }, this);

            return rules;

        }.bind(this);

        this.generateRuleCondition = function () {

            var id = this.nextRule;
            var ruleBy = new Greenmile.PanelBuilder.Rule(this, id);
            this.rules[id] = ruleBy;
            var defaultRule = this.fieldsContainer.querySelector('.defaultRule');
            var newRule = ruleBy.render();
            if (defaultRule) {
                this.fieldsContainer.insertBefore(newRule, defaultRule);
            } else {
                this.fieldsContainer.appendChild(newRule);
            }

            form.rootEl.scrollTop = this.fieldsContainer.getBoundingClientRect().bottom;

            this.nextRule++;

            return ruleBy;

        }.bind(this);

        this.fieldsContainerSortable = function () {

            var moveCounter = 0;

            $(this.fieldsContainer).sortable({
                axis: 'y',
                revert: true,
                scroll: false,
                cursor: 'move',
                handle: '.dragAndDrop',
                sort: function() {
                    moveCounter++;
                },
                start: function() {
                    moveCounter = 0;
                },
                stop: function(ev,ui){
                    if(moveCounter<3) {
                        $(ui.item).trigger("click");
                    }
                }
            });
        };

        this.getRulesSection = function () {

            this.rootEl = document.createElement('div');
            this.fieldsContainer = document.createElement('div');

            this.rootEl.className = 'rulesSection';
            this.fieldsContainer.className = 'fieldsContainer';

            this.fieldsContainerSortable();

            this.rootEl.appendChild(Greenmile.PanelBuilder.Utils.getSectionTitleWithBtnNew('Greenmile.PanelBuilder.RulesEditor', this.generateRuleCondition));
            this.rootEl.appendChild(this.fieldsContainer);

            var rule = this.generateRuleCondition();
            rule.ruleName.input.value = Monet.I18n.getResourcesByKey('PanelBuilder.defaultRule');
            rule.rootEl.className += ' defaultRule';

            return this.rootEl;

        }.bind(this);

    }

    return RuleManager;

}());
